import { defineMessages } from 'react-intl';

export default defineMessages({
    category: {
        id: 'policycommon.component.discountSurcharge.Category',
        defaultMessage: 'Category'
    },
    applied: {
        id: 'policycommon.component.discountSurcharge.Applied',
        defaultMessage: 'Applied'
    },
    discountsandSurcharges: {
        id: 'policycommon.component.discountSurcharge.Discounts and Surcharges',
        defaultMessage: 'Discounts and Surcharges'
    }
});
